"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import i18n from "@/lang";
import UiDrawer from "@/components/drawer/UiDrawer.vue";
import UiForm, {
  UiFormController
} from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { Debounce } from "vue-debounce-decorator";
import { DrawerComponent } from "@/components/core";
class FormController extends UiFormController {
}
let MyTeamSearchForm = class extends DrawerComponent {
  constructor() {
    super(...arguments);
    this.roles = null;
    this.departments = null;
    this.locks = [
      {
        "id": "NORMAL",
        "name": this.$t("team_management.my_team.lock_false")
      },
      {
        "id": "LOCK",
        "name": this.$t("team_management.my_team.lock_true")
      }
    ];
  }
  get $query() {
    return this._query;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getRoles();
      yield this.getDepartments();
    });
  }
  static create(query) {
    const _vue = new this({
      i18n,
      el: document.createElement("div"),
      propsData: {
        query
      }
    });
    return _vue;
  }
  search() {
    return __async(this, null, function* () {
      try {
        let searchParams = {
          params: {}
        };
        if (!this.isEmptyString(this.$query.name)) {
          searchParams.params["name"] = this.$query.name;
        }
        if (!this.isEmptyString(this.$query.user_no)) {
          searchParams.params["user_no"] = this.$query.user_no;
        }
        if (!this.isEmptyString(this.$query.department_id)) {
          searchParams.params["department_id"] = this.$query.department_id;
        }
        if (!this.isEmptyString(this.$query.phone)) {
          searchParams.params["phone"] = this.$query.phone;
        }
        if (!this.isEmptyString(this.$query.role_id)) {
          searchParams.params["role_id"] = this.$query.role_id;
        }
        if (!this.isEmptyString(this.$query.lock)) {
          searchParams.params["status"] = this.$query.lock;
        }
        this.$emit("search", searchParams);
      } catch (error) {
      }
    });
  }
  isEmptyString(str) {
    if (str === "" || str === null || str === void 0) {
      return true;
    } else {
      return false;
    }
  }
  clearDrawer() {
    return __async(this, null, function* () {
      this.$query.user_no = null;
      this.$query.name = null;
      this.$query.department_id = null;
      this.$query.role_id = null;
      this.$query.phone = null;
      this.$query.lock = null;
      yield this.search();
    });
  }
  getRoles() {
    return __async(this, null, function* () {
      try {
        this.roles = null;
        const response = yield API.get(`api://base.auth/api/v1/roles`);
        if (response.data) {
          this.roles = response.data.datas;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getDepartments() {
    return __async(this, null, function* () {
      try {
        this.departments = null;
        const response = yield API.get(`api://base.auth/api/v1/departments`);
        if (response.data) {
          let arr = [];
          arr.push(response.data);
          this.departments = yield this.formatdata(arr, []);
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  formatdata(data, arr) {
    return __async(this, null, function* () {
      if (arr.length === 0) {
        arr = [];
      }
      for (let item of data) {
        let _data = {
          id: item.id,
          name: item.label
        };
        arr.push(_data);
        if (item.hasOwnProperty("children") === false) {
          continue;
        }
        if (item.children === null) {
          delete item.children;
          continue;
        }
        if (item.children.length === 0) {
          delete item.children;
          continue;
        }
        if (item.children !== void 0 && item.children.length > 0) {
          this.formatdata(item.children, arr);
        }
      }
      return arr;
    });
  }
};
__decorateClass([
  PropSync("query")
], MyTeamSearchForm.prototype, "_query", 2);
__decorateClass([
  Debounce(800)
], MyTeamSearchForm.prototype, "search", 1);
MyTeamSearchForm = __decorateClass([
  Component({
    components: {
      UiDrawer,
      UiForm,
      UiSubmit
    }
  })
], MyTeamSearchForm);
export {
  MyTeamSearchForm as default
};
